import { zodResolver } from '@hookform/resolvers/zod';
import { createFileRoute, useParams, useRouter } from '@tanstack/react-router';
import { Button } from 'components/Button';
import { emitMessage } from 'engine/api';
import { FormProvider, useForm } from 'react-hook-form';
import { UpdateUserForm } from 'forms/UserForm';
import { UpdateUserRecordSchema, type UpdateUserRecord } from 'shared/modelTypes/user';
import { CheckCheck, X } from 'lucide-react';
import { toast } from 'sonner';

export const Route = createFileRoute('/dashboard/users/$id')({
	component: RouteComponent,
	loader: async ({ params }) => {
		const user = await emitMessage({ kind: 'get-user', userId: params.id });
		if ('error' in user) {
			throw new Error(user.error);
		}
		return UpdateUserRecordSchema.parse(user);
	},
});

function RouteComponent() {
	return (
		<div>
			<UserForm />
		</div>
	);
}

function UserForm() {
	const data = Route.useLoaderData();
	const { id } = useParams({ from: '/dashboard/users/$id' });
	const router = useRouter();

	const methods = useForm<UpdateUserRecord>({
		resolver: zodResolver(UpdateUserRecordSchema),
		defaultValues: { ...data, password: undefined },
	});

	const err = methods.formState.errors;

	const onSubmit = async (data: UpdateUserRecord) => {
		const r = await emitMessage({
			kind: 'update-user',
			userId: id,
			data,
		});

		console.log('register result:', r);
		if (r.success) {
			toast('User updated successfully!', { icon: <CheckCheck /> });
			router.navigate({ to: '/dashboard/users' });
		} else {
			toast('Could not update user', { icon: <X /> });
		}
	};

	if (!data) {
		return <div>Error loading user data</div>;
	}

	console.log(err);
	return (
		<FormProvider {...methods}>
			<form className="flex flex-col gap-3" onSubmit={methods.handleSubmit(onSubmit)}>
				<UpdateUserForm label="Update User" />
				<Button type="submit">Submit</Button>
			</form>
		</FormProvider>
	);
}
